import React from 'react'

const MprolabIconContrast: React.FC = () => {
  return (
    <svg width="156" height="26" viewBox="0 0 156 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="MPROLab_Mono_White 1" clipPath="url(#clip0_95_29613)">
        <g id="Layer 1">
          <g id="Group">
            <g id="Group_2">
              <path
                id="Vector"
                d="M72.2837 11.129V20.1456H68.5321V11.3904C68.5321 9.66111 67.658 8.607 66.0873 8.607C64.43 8.607 63.3829 9.71774 63.3829 11.9174V20.1456H59.6313V11.3904C59.6313 9.66111 58.7572 8.607 57.1865 8.607C55.6158 8.607 54.4518 9.71774 54.4518 11.9174V20.1456H50.7002V5.50564H54.4518V7.05632C55.2653 5.82797 56.6326 5.09619 58.4933 5.09619C60.3539 5.09619 61.6347 5.85846 62.4482 7.20442C63.3483 5.88895 64.8022 5.09619 66.7796 5.09619C70.0942 5.09619 72.275 7.46577 72.275 11.129H72.2837Z"
                fill="#999999"
              />
              <path
                id="Vector_2"
                d="M89.964 12.8278C89.964 17.188 86.7663 20.5551 82.8676 20.5551C80.743 20.5551 79.2025 19.7667 78.1554 18.4163V25.9999H74.4038V5.50564H78.1554V7.23491C79.2025 5.88895 80.743 5.09619 82.8676 5.09619C86.7663 5.09619 89.964 8.46326 89.964 12.8235V12.8278ZM86.2124 12.8278C86.2124 10.3668 84.4946 8.69847 82.1709 8.69847C79.8473 8.69847 78.1554 10.3668 78.1554 12.8278C78.1554 15.2889 79.8732 16.9571 82.1709 16.9571C84.4686 16.9571 86.2124 15.2889 86.2124 12.8278Z"
                fill="#999999"
              />
              <path
                id="Vector_3"
                d="M99.7085 5.21387V9.43032C97.7613 9.1951 95.2863 10.075 95.2863 13.1502V20.1457H91.5347V5.50571H95.2863V8.02338C96.0435 6.03276 97.8738 5.21387 99.7085 5.21387Z"
                fill="#999999"
              />
              <path
                id="Vector_4"
                d="M99.5054 12.8278C99.5054 8.46329 102.906 5.10059 107.182 5.10059C111.457 5.10059 114.888 8.46765 114.888 12.8278C114.888 17.188 111.457 20.5551 107.182 20.5551C102.906 20.5551 99.5054 17.188 99.5054 12.8278ZM111.137 12.8278C111.137 10.4583 109.419 8.78563 107.182 8.78563C104.945 8.78563 103.257 10.4539 103.257 12.8278C103.257 15.2018 104.975 16.8701 107.182 16.8701C109.388 16.8701 111.137 15.2018 111.137 12.8278Z"
                fill="#999999"
              />
              <g id="Group_3">
                <path id="Vector_5" d="M118.523 0H119.856V19.9846H118.523V0Z" fill="#999999" />
                <path
                  id="Vector_6"
                  d="M137.424 5.57566V19.9804H136.147V16.4827C135.087 18.8087 132.971 20.281 130.254 20.281C126.208 20.281 123.248 17.0533 123.248 12.7628C123.248 8.4723 126.234 5.35352 130.254 5.35352C132.971 5.35352 135.087 6.77352 136.147 9.0734V5.57566H137.424ZM136.121 12.7672C136.121 9.07776 133.759 6.50781 130.366 6.50781C126.974 6.50781 124.607 9.21279 124.607 12.7672C124.607 16.3215 127.052 19.057 130.366 19.057C133.681 19.057 136.121 16.4609 136.121 12.7672Z"
                  fill="#999999"
                />
                <path
                  id="Vector_7"
                  d="M156 12.767C156 17.0575 153.014 20.2851 148.968 20.2851C146.281 20.2851 144.161 18.8346 143.075 16.513V19.9846H141.824V0H143.157V8.85542C144.269 6.66879 146.363 5.30106 148.994 5.30106C153.014 5.30106 156 8.49824 156 12.7626V12.767ZM154.645 12.767C154.645 9.2126 152.175 6.50762 148.886 6.50762C145.597 6.50762 143.131 9.07757 143.131 12.767C143.131 16.4564 145.494 19.0568 148.886 19.0568C152.278 19.0568 154.645 16.378 154.645 12.767Z"
                  fill="#999999"
                />
              </g>
            </g>
            <path
              id="Vector_8"
              d="M38.1562 8.11074V17.8722L31.3021 24.7718H21.6051L11.8086 14.9058L13.6909 13.0111L22.7085 22.0973H30.2074L35.508 16.7614V9.21277L27.5678 1.22852H31.3194L38.1519 8.11074H38.1562ZM16.5727 1.22852H6.83679L0 8.11074V17.8722L6.8541 24.7718H10.6057L2.6525 16.7614V9.21277L7.95318 3.87687H15.452L24.4826 12.9675L26.3606 11.0771L16.5727 1.22852ZM24.0023 1.22852H20.3113L30.3718 11.3558V14.6227L28.0784 16.9313H24.8331L14.4092 6.42067H9.00466L5.18385 10.2669V15.7073L14.1842 24.7675H17.8752L7.79308 14.6184V11.3515L10.0864 9.04289H13.3317L23.7557 19.5535H29.1602L32.981 15.7073V10.2669L24.0023 1.22852Z"
              fill="#999999"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_95_29613">
          <rect width="156" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MprolabIconContrast
